export const translations = {
  de: {
    nav: {
      home: "Home",
      academy: "Akademie",
      music: "School of Music",
      dance: "School of Dance",
      workshops: "Workshops",
      events: "Events",
      teachers: "Lehrpersonen",
      gallery: "Galerie",
      contact: "Kontakt",
      enroll: "Anmeldung",
      about: "Über uns",
    },
    cta: {
      enrollNow: "Jetzt anmelden",
      discover: "Akademie entdecken",
      readMore: "Mehr erfahren",
      register: "Anmelden",
      backHome: "Zur Startseite",
      contactUs: "Kontaktiere uns",
      viewAll: "Alle ansehen",
    },
    hero: {
      headline: "Wo Tradition auf Talent trifft.",
      sub: "Die KK Academy ist die Akademie für Performing Arts & Culture in Wil SG, zentral in der Ostschweiz. Wir fördern Talente, bewahren kulturelle Traditionen und schaffen einen Ort, an dem Musik, Tanz und Kultur Menschen verbinden, inspirieren und begeistern.",
      eyebrow: "Academy of Performing Arts & Culture",
    },
    home: {
      academyOverview: "Unsere Akademie",
      academyIntro: "Zwei Welten – eine Leidenschaft. Entdecke unsere School of Music und School of Dance.",
      musicTitle: "School of Music",
      musicTitleTamil: "இசை",
      musicSub: "Mirudangam · Violine · Veenai · Sangitham",
      danceTitle: "School of Dance",
      danceTitleTamil: "நாட்டியம்",
      danceSub: "Bollywood · Kuthu · HipHop · Performance Teams",
      workshopsTitle: "Aktuelle Workshops",
      workshopsSub: "Lerne von erfahrenen Lehrpersonen in fokussierten Sessions.",
      eventsTitle: "Kommende Events",
      eventsSub: "Konzerte, Talent Shows und Kulturveranstaltungen.",
      teachersTitle: "Unsere Fachbereichsleitungen",
      teachersSub: "Erfahrene Künstler und Pädagogen.",
      galleryTitle: "Galerie",
      gallerySub: "Momente, die wir bewahren.",
      ctaTitle: "Werde Teil der KK Academy.",
      ctaSub: "Egal ob Anfänger oder Fortgeschrittener – bei uns findest du deinen Platz.",
    },
    footer: {
      tagline: "Academy of Performing Arts & Culture",
      followUs: "Folge uns",
      about: "Über uns",
      privacy: "Datenschutz",
      imprint: "Impressum",
      rights: "Alle Rechte vorbehalten",
      navigation: "Navigation",
      legal: "Rechtliches",
    },
    department: {
      teacher: "Fachbereichsleitung",
      schedule: "Kurszeiten",
      price: "Preis",
      pricePerLesson: "pro Lektion",
      location: "Ort",
      status: "Status",
      active: "Aktiv",
      comingSoon: "Coming Soon",
      enrollTitle: "Jetzt anmelden",
      gallery: "Galerie",
      description: "Beschreibung",
    },
    workshop: {
      date: "Datum",
      time: "Uhrzeit",
      location: "Ort",
      teacher: "Lehrperson",
      price: "Preis",
      max: "Max. Teilnehmer",
      deadline: "Anmeldeschluss",
      language: "Sprache",
      open: "Offen",
      full: "Ausgebucht",
      closed: "Abgeschlossen",
    },
    event: {
      planned: "Geplant",
      done: "Abgeschlossen",
    },
    enroll: {
      title: "Anmeldung",
      sub: "Fülle das Formular aus – wir melden uns innerhalb von 48 Stunden.",
      firstName: "Vorname Schüler",
      lastName: "Nachname Schüler",
      birthDate: "Geburtsdatum",
      parentName: "Name Elternteil",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      category: "Gewünschter Bereich",
      course: "Gewünschter Kurs / Instrument / Tanzrichtung / Workshop",
      note: "Bemerkung",
      privacy: "Ich akzeptiere die Datenschutzbestimmungen",
      submit: "Anmeldung absenden",
      success: "Vielen Dank! Deine Anmeldung wurde erfolgreich übermittelt.",
      music: "School of Music",
      dance: "School of Dance",
      workshop: "Workshop",
    },
    contact: {
      title: "Kontakt",
      sub: "Wir freuen uns auf deine Nachricht.",
      name: "Name",
      message: "Nachricht",
      send: "Nachricht senden",
      success: "Nachricht gesendet – wir melden uns bald.",
    },
    about: {
      title: "Über KK Academy",
      sub: "Eine Brücke zwischen Tradition und Zukunft.",
    },
  },
  en: {
    nav: { home: "Home", academy: "Academy", music: "School of Music", dance: "School of Dance", workshops: "Workshops", events: "Events", teachers: "Teachers", gallery: "Gallery", contact: "Contact", enroll: "Enroll", about: "About" },
    cta: { enrollNow: "Enroll Now", discover: "Discover the Academy", readMore: "Learn more", register: "Register", backHome: "Back to home", contactUs: "Contact us", viewAll: "View all" },
    hero: { headline: "Where tradition meets talent.", sub: "KK Academy is the academy for Performing Arts & Culture in Wil SG, at the heart of Eastern Switzerland. We nurture talent, preserve cultural traditions and create a place where music, dance and culture connect, inspire and excite people.", eyebrow: "Academy of Performing Arts & Culture" },
    home: { academyOverview: "Our Academy", academyIntro: "Two worlds – one passion. Discover our School of Music and School of Dance.", musicTitle: "School of Music", musicTitleTamil: "இசை", musicSub: "Mirudangam · Violin · Veenai · Vocals", danceTitle: "School of Dance", danceTitleTamil: "நாட்டியம்", danceSub: "Bollywood · Kuthu · HipHop · Performance Teams", workshopsTitle: "Current workshops", workshopsSub: "Learn from experienced teachers in focused sessions.", eventsTitle: "Upcoming events", eventsSub: "Concerts, talent shows and cultural events.", teachersTitle: "Our heads of departments", teachersSub: "Experienced artists and educators.", galleryTitle: "Gallery", gallerySub: "Moments we keep.", ctaTitle: "Become part of KK Academy.", ctaSub: "Whether beginner or advanced – you'll find your place here." },
    footer: { tagline: "Academy of Performing Arts & Culture", followUs: "Follow us", about: "About", privacy: "Privacy", imprint: "Imprint", rights: "All rights reserved", navigation: "Navigation", legal: "Legal" },
    department: { teacher: "Head of department", schedule: "Schedule", price: "Price", pricePerLesson: "per lesson", location: "Location", status: "Status", active: "Active", comingSoon: "Coming soon", enrollTitle: "Enroll now", gallery: "Gallery", description: "Description" },
    workshop: { date: "Date", time: "Time", location: "Location", teacher: "Teacher", price: "Price", max: "Max. participants", deadline: "Registration deadline", language: "Language", open: "Open", full: "Full", closed: "Closed" },
    event: { planned: "Planned", done: "Done" },
    enroll: { title: "Registration", sub: "Fill out the form – we'll reply within 48 hours.", firstName: "Student first name", lastName: "Student last name", birthDate: "Date of birth", parentName: "Parent name", phone: "Phone", email: "Email", address: "Address", category: "Desired area", course: "Desired course / instrument / dance / workshop", note: "Note", privacy: "I accept the privacy policy", submit: "Submit registration", success: "Thank you! Your registration was submitted.", music: "Music academy", dance: "Dance academy", workshop: "Workshop" },
    contact: { title: "Contact", sub: "We look forward to your message.", name: "Name", message: "Message", send: "Send message", success: "Message sent – we'll be in touch." },
    about: { title: "About KK Academy", sub: "A bridge between tradition and the future." },
  },
  ta: {
    nav: { home: "முகப்பு", academy: "அகாடமி", music: "School of Music", dance: "School of Dance", workshops: "பயிற்சிப்பட்டறைகள்", events: "நிகழ்வுகள்", teachers: "ஆசிரியர்கள்", gallery: "புகைப்படத் தொகுப்பு", contact: "தொடர்பு", enroll: "பதிவு", about: "எங்களைப் பற்றி" },
    cta: { enrollNow: "இப்போது பதிவு செய்க", discover: "அகாடமியை அறிக", readMore: "மேலும் அறிய", register: "பதிவு செய்", backHome: "முகப்புக்கு திரும்பு", contactUs: "தொடர்பு கொள்ள", viewAll: "அனைத்தையும் காண" },
    hero: { headline: "கலையும் இசையும் நடனமும் ஒன்றுசேரும் இடம்.", sub: "KK அகாடமி சுவிட்சர்லாந்தில் தமிழ் கலை மற்றும் கலாச்சாரத்திற்கான முதன்மை அகாடமி. திறமையை வளர்த்து, பாரம்பரியத்தை பாதுகாத்து, இசை, நடனம், பயிற்சிப்பட்டறைகள் மற்றும் கலாச்சார நிகழ்வுகளுக்கான தளத்தை உருவாக்குகிறோம்.", eyebrow: "கலை மற்றும் கலாச்சார அகாடமி" },
    home: { academyOverview: "எங்கள் அகாடமி", academyIntro: "இரண்டு உலகங்கள் – ஒரே ஆர்வம். எங்கள் School of Music மற்றும் School of Dance ஐ கண்டுபிடி.", musicTitle: "School of Music", musicTitleTamil: "தாளம்", musicSub: "மிருதங்கம் · வயலின் · வீணை · சங்கீதம்", danceTitle: "School of Dance", danceTitleTamil: "நாட்டியம்", danceSub: "பாலிவுட் · குத்து · ஹிப்ஹாப் · Performance Teams", workshopsTitle: "தற்போதைய பயிற்சிப்பட்டறைகள்", workshopsSub: "அனுபவம் வாய்ந்த ஆசிரியர்களிடமிருந்து கற்றுக்கொள்ளுங்கள்.", eventsTitle: "வரவிருக்கும் நிகழ்வுகள்", eventsSub: "இசை நிகழ்ச்சிகள், திறமை காட்சிகள், கலாச்சார நிகழ்வுகள்.", teachersTitle: "எங்கள் துறைத் தலைவர்கள்", teachersSub: "அனுபவம் வாய்ந்த கலைஞர்கள் மற்றும் ஆசிரியர்கள்.", galleryTitle: "புகைப்படத் தொகுப்பு", gallerySub: "நாம் காப்பாற்றும் கணங்கள்.", ctaTitle: "KK அகாடமியின் ஒரு பகுதியாக ஆகுங்கள்.", ctaSub: "ஆரம்பநிலை அல்லது முன்னேறிய – உங்களுக்கான இடம் இங்கே உள்ளது." },
    footer: { tagline: "கலை மற்றும் கலாச்சார அகாடமி", followUs: "எங்களை பின்தொடரவும்", about: "எங்களைப் பற்றி", privacy: "தனியுரிமை", imprint: "சட்ட விவரம்", rights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை", navigation: "வழிசெலுத்தல்", legal: "சட்டம்" },
    department: { teacher: "துறைத் தலைவர்", schedule: "பாட நேரங்கள்", price: "கட்டணம்", pricePerLesson: "ஒரு பாடத்திற்கு", location: "இடம்", status: "நிலை", active: "செயலில்", comingSoon: "விரைவில்", enrollTitle: "இப்போது பதிவு செய்க", gallery: "புகைப்படத் தொகுப்பு", description: "விளக்கம்" },
    workshop: { date: "தேதி", time: "நேரம்", location: "இடம்", teacher: "ஆசிரியர்", price: "கட்டணம்", max: "அதிகபட்ச பங்கேற்பாளர்கள்", deadline: "பதிவு கடைசி தேதி", language: "மொழி", open: "திறந்துள்ளது", full: "நிரம்பியது", closed: "முடிந்தது" },
    event: { planned: "திட்டமிடப்பட்டது", done: "முடிந்தது" },
    enroll: { title: "பதிவு", sub: "படிவத்தை நிரப்பவும் – 48 மணி நேரத்தில் உங்களைத் தொடர்பு கொள்வோம்.", firstName: "மாணவர் முதல்பெயர்", lastName: "மாணவர் குடும்பப்பெயர்", birthDate: "பிறந்த தேதி", parentName: "பெற்றோர் பெயர்", phone: "தொலைபேசி", email: "மின்னஞ்சல்", address: "முகவரி", category: "விரும்பிய துறை", course: "விரும்பிய பாடம் / இசைக்கருவி / நடனம் / பட்டறை", note: "குறிப்பு", privacy: "தனியுரிமை கொள்கையை ஏற்கிறேன்", submit: "பதிவை சமர்ப்பிக்கவும்", success: "நன்றி! உங்கள் பதிவு சமர்ப்பிக்கப்பட்டது.", music: "இசை அகாடமி", dance: "நடன அகாடமி", workshop: "பட்டறை" },
    contact: { title: "தொடர்பு", sub: "உங்கள் செய்திக்காக காத்திருக்கிறோம்.", name: "பெயர்", message: "செய்தி", send: "செய்தி அனுப்பு", success: "செய்தி அனுப்பப்பட்டது – விரைவில் தொடர்பு கொள்வோம்." },
    about: { title: "KK அகாடமி பற்றி", sub: "பாரம்பரியம் மற்றும் எதிர்காலத்தின் இடையே ஒரு பாலம்." },
  },
};
